import { bl_fi_mst_entity_vehicle_brand_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_brand.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleBrandContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_brand: bl_fi_mst_entity_vehicle_brand_RowClass = new bl_fi_mst_entity_vehicle_brand_RowClass();
}
